// Sale Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get productionList from backend then update productionList in vuex store ***** //
export const updateSalesList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('sales_index', { params: params })
    commit('updateSalesList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Get saleList from backend then update saleList in vuex store ***** //
export const updateReportSaleList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`report_sales/${payload.id}`, {
      params: params
    })
    commit('updateSalesList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch Sale from backend ***** //
export const fetchSaleInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`sales_show/${payload}`)
    commit('fetchSaleInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Sale  ***** //
export const addSale = async (ignored, payload = null) => {
  try {
    await Axios.post('sales_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Sale  info ***** //
export const updateSaleInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`sales_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete Sale  ***** //
export const deleteSale = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`sales_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

// ***** Close Sale  ***** //
export const closeSale = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`sales_close/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Closed Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, close failed')
  }
}

// ***** UnClose Sale  ***** //
export const uncloseSale = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`sales_unclose/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Opened Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, open failed')
  }
}

export const fetchReportUnClosedSalesCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_unclosed_sale_count/${payload}`)
    commit('fetchReportUnClosedSalesCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching count data failed')
  }
}

export const fetchReportUnPaidSalesCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_unpaid_sale_count/${payload}`)
    commit('fetchReportUnPaidSalesCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching count data failed')
  }
}

export const fetchUnClosedSalesCount = async ({ commit }) => {
  try {
    const result = await Axios.get('unclosed_sale_count')
    commit('fetchUnClosedSalesCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching count data failed')
  }
}

export const fetchUnPaidSalesCount = async ({ commit }) => {
  try {
    const result = await Axios.get('unpaid_sale_count')
    commit('fetchUnPaidSalesCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching count data failed')
  }
}
